import React, { Component } from 'react';
import { change } from 'redux-form';
import { withTranslation } from 'react-i18next';

import { Wrapper, Checkbox, InputBox, Popup, Select } from './Multiselect.styled';

class Multiselect extends Component {
  constructor() {
    super();
    this.state = { popupIsOpen: false };
    this.popup = React.createRef();
  }

  showPopup = () => {
    const { disabled } = this.props;
    if (disabled) return;

    if (!this.state.popupIsOpen) {
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
    this.setState({ popupIsOpen: !this.state.popupIsOpen });
  };

  handleOutsideClick = (e) => {
    if (this.popup) {
      if (this.popup.contains(e.target)) return;
      this.showPopup();
    }
  };

  setValue = (e, fieldValue) => {
    const { name, value } = this.props.input;
    const { dispatch, form } = this.props.meta;

    let newValue = [...value];

    if (e.target.checked) {
      newValue.push(fieldValue);
    } else {
      newValue.splice(newValue.indexOf(fieldValue), 1);
    }

    // need cuz empty string not storing in form reducer
    // unlike empty array
    if (newValue.length === 0) newValue = '';

    dispatch(change(form, name, newValue));
  };

  getInputs = () => {
    const {
      data,
      input: { value },
    } = this.props;

    if (Array.isArray(data)) {
      return data.map((elem) => {
        return (
          <Checkbox key={elem.id} className="checkbox">
            <input
              onChange={(e) => this.setValue(e, elem.id)}
              type="checkbox"
              name={elem.name}
              checked={Array.isArray(value) ? value.includes(elem.id) : false}
            />
            <label>{elem.name}</label>
          </Checkbox>
        );
      });
    }
  };

  getDisplayedValue = () => {
    const {
      data,
      input: { value },
    } = this.props;
    if (Array.isArray(value)) {
      let displayedValue = '';

      value.forEach((id) => {
        data.forEach((elem) => {
          if (id === elem.id) {
            if (displayedValue) {
              displayedValue += `, ${elem.name}`;
            } else {
              displayedValue += elem.name;
            }
          }
        });
      });
      return displayedValue;
    } else return '';
  };

  isCheckedAll = () => {
    const {
      data,
      input: { value },
    } = this.props;

    if (Array.isArray(value)) {
      return value.length === data.length;
    } else return false;
  };

  selectAll = () => {
    const { dispatch, form } = this.props.meta;
    const {
      data,
      input: { value, name },
    } = this.props;

    let newValue = '';

    if (!value || value.length !== data.length) {
      newValue = data.map((elem) => {
        return elem.id;
      });
    }

    dispatch(change(form, name, newValue));
  };

  render() {
    const { t } = this.props;
    return (
      <Wrapper className={this.props.className}>
        <label>{this.props.label}</label>
        <Select ref={this.popup}>
          <InputBox onClick={this.showPopup}>
            <input placeholder={this.props.placeholder} value={this.getDisplayedValue()} disabled />
          </InputBox>
          <Popup popupIsOpen={this.state.popupIsOpen}>
            <Checkbox className="checkbox">
              <input onChange={this.selectAll} checked={this.isCheckedAll()} type="checkbox" name="all" />
              <label>{t('filters.Все')}</label>
            </Checkbox>
            {this.getInputs()}
          </Popup>
        </Select>
      </Wrapper>
    );
  }
}

export default withTranslation()(Multiselect);
